<template>
    <div class="staff">
<!--        <el-card>-->
<!--            <el-page-header @back="goBack" content="商品"></el-page-header>-->
<!--        </el-card>-->
        <main class="content">
            <el-tabs type="border-card" @tab-click="tabClick">
                <el-tab-pane label="基本属性">
                    <el-form ref="productSetForm" :model="productSetForm" :rules="rules" label-width="100px">
                        <el-form-item label="商品组名称" prop="name">
                            <el-input v-model="productSetForm.name" placeholder="请输入商品组名称" :disabled="productSetId != undefined" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="品牌">
                            <el-select style="width:100%"
                                v-model="productSetForm.brandId"
                                filterable
                                remote
                                clearable
                                reserve-keyword
                                placeholder="请输入品牌名称"
                                :remote-method="loadBrand"
                                :loading="brandLoading"
                                :disabled="productSetId != undefined">
                                    <el-option
                                    v-for="item in brands"
                                    :key="item.id"
                                    :label="item.nameCh + ' (' + item.nameEn + ')'"
                                    :value="item.id"
                                    ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="分类" prop="categoryIds">
                            <el-cascader v-model="productSetForm.categoryIds" :props="category" placeholder="请选择分类" style="width:100%" :disabled="productSetId"></el-cascader>
                        </el-form-item>
                        <el-form-item label="更多分类">
                            <el-button type="primary" @click="showMoreCategoryDialog" :disabled="productSetId != undefined">关联更多分类</el-button>
                            <!-- <el-cascader v-model="productSetForm.relationCategoryIds" :props="relationCategory" placeholder="请选择分类" style="width:100%"></el-cascader> -->
                        </el-form-item>
                        <el-form-item label="属性模板" prop="templateId">
                            <el-select style="width:100%"
                                v-model="productSetForm.templateId"
                                filterable
                                remote
                                clearable
                                reserve-keyword
                                placeholder="请输入属性模板名称"
                                :remote-method="loadTemplate"
                                :loading="templateLoading"
                                :disabled="productSetId != undefined"
                                @change="changeTemplate">
                                    <el-option
                                    v-for="item in templates"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                    ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="封面图" prop="thumbnail">
                            <el-upload
                                class="avatar-uploader"
                                ref="upload"
                                action="/api/admin/uploadImage"
                                name="file"
                                list-type="picture-card"
                                :show-file-list="false"
                                :file-list="fileList"
                                :on-exceed="onExceed"
                                :before-upload="beforeUpload"
                                :on-preview="handlePreview"
                                :on-success="handleSuccess"
                                :on-remove="handleRemove"
                                :disabled="productSetId != undefined">
                                <img v-if="productSetForm.thumbnail" width="100%" :src="'/api'+productSetForm.thumbnail"  class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="货期">
                            <el-input v-model="productSetForm.delivery" placeholder="请输入货期" :disabled="productSetId != undefined" clearable>
                                <template slot="append">天</template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="单位">
                            <el-input v-model="productSetForm.unit" placeholder="请输入商品单位" :disabled="productSetId != undefined" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="介绍">
                            <quill-editor v-model="productSetForm.description"
                                :options="editorOption" :disabled="productSetId != undefined">
                            </quill-editor>
                        </el-form-item>
                    </el-form>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="onSubmitProductSet" :disabled="productSetId != undefined">保 存</el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane :label="productSetId === undefined ? '商品信息(保存基本信息后才能编辑)' : '商品信息'" :disabled="productSetId === undefined">
                    <el-table stripe size="mini" :data="productData" v-loading="loading" style="width: 100%">
                        <el-table-column prop="sku" label="编号" width="160"/>
                        <el-table-column prop="name" label="名称"/>
                        <el-table-column prop="model" label="型号" width="120"/>
                        <el-table-column prop="delivery" label="货期" :formatter="deliveryFormatter" width="80"/>
                        <el-table-column prop="unit" label="单位" width="80"/>
                        <el-table-column prop="price" label="价格" width="100" :formatter="priceFormatter"/>
                        <el-table-column prop="status" label="状态" width="80">
                            <template slot-scope="scope">
                                <el-tag type="danger" v-if="scope.row.status == 0">草稿</el-tag>
                                <el-tag type="warning" v-if="scope.row.status == 1">待审核</el-tag>
                                <el-tag type="success" v-if="scope.row.status == 2">部分上架</el-tag>
                                <el-tag type="success" v-if="scope.row.status == 3">上架</el-tag>
                                <el-tag type="warning" v-if="scope.row.status == 4">驳回</el-tag>
                                <el-tag type="warning" v-if="scope.row.status == 5">待下架</el-tag>
                                <el-tag type="info" v-if="scope.row.status == 6">下架</el-tag>
                            </template>
                    </el-table-column>
                        <el-table-column prop="recommend" label="是否推荐" width="80">
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.recommend ===  1 ? 'primary' : 'info'" disable-transitions>
                                    {{scope.row.recommend === 1 ? "是" : "否" }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="280" align="right">
                            <template slot="header">
                                <el-button type="primary" @click="handleCreateProduct" size="mini">添加</el-button>
                            </template>
                            <template slot-scope="scope">
                                <el-button size="mini" :disabled="scope.row.status!==0 && scope.row.status!==6" @click="handleToPending(scope.$index, scope.row)">提交</el-button>
                                <el-button size="mini" :disabled="scope.row.status!==0 && scope.row.status!==4 && scope.row.status!==6" @click="handleEditProduct(scope.$index, scope.row)">编辑</el-button>
                                <el-button size="mini" :disabled="scope.row.status!==0 && scope.row.status!==3 && scope.row.status!==4" type="danger" @click="handleToPendingOff(scope.$index, scope.row)">下架</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="text-align: center;padding-top: 20px">
                        <el-pagination
                            background
                            layout="sizes,prev, pager, next"
                            :page-sizes="[10, 20, 50, 100]"
                            v-if="total>0"
                            :total="productTotal"
                            :page-size="productPageSize"
                            @size-change="handleSizeChange"
                            @current-change="onPageChange"
                            @prev-click="onPageChange"
                            @next-click="onPageChange">
                        </el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </main>
        <el-dialog title="商品信息" :visible.sync="editDialogVisible" width="800px" :close-on-click-modal="false">
            <el-form ref="productForm" :model="productForm" :rules="rules" label-width="80px">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="productForm.name" placeholder="请输入商品名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="编号" prop="sku">
                    <el-input v-model="productForm.sku" placeholder="请输入商品编号" clearable></el-input>
                </el-form-item>
                <el-form-item label="型号">
                    <el-input v-model="productForm.model" placeholder="请输入商品型号" clearable></el-input>
                </el-form-item>
                <el-form-item label="单位">
                    <el-input v-model="productForm.unit" placeholder="请输入商品单位" clearable></el-input>
                </el-form-item>
                <el-form-item label="货期">
                    <el-input v-model="productForm.delivery" placeholder="请输入货期" clearable>
                        <template slot="append">天</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="商品价格">
                    <el-input v-model="productForm.price" placeholder="请输入商品价格" clearable>
                        <template slot="prepend">￥</template>
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item v-for="property in productForm.properties" :key="property.id" :label="property.name">
                    <el-input v-model="property.value" :placeholder="'请输入商品' + property.name" clearable>
                        <template slot="append" v-if="property.unit">{{property.unit}}</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="图片">
                    <el-upload
                        class="picture-card"
                        ref="uploadImages"
                        action="/api/admin/uploadImage"
                        name="file"
                        list-type="picture-card"
                        :limit="3"
                        :file-list="images"
                        :on-exceed="onImageExceed"
                        :before-upload="beforeImageUpload"
                        :on-preview="handleImagePreview"
                        :on-success="handleImageSuccess"
                        :on-remove="handleImageRemove">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="是否推荐">
                    <el-select v-model="productForm.recommend" placeholder="请选择是否推荐" clearable>
                        <el-option label="否" value="0"></el-option>
                        <el-option label="是" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="介绍">
                    <quill-editor v-model="productForm.description" :options="editorOption"></quill-editor>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmitProduct">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="关联更多分类" :visible.sync="relationCategoryDialogVisible" width="500px" :close-on-click-modal="false">
            <el-form :model="productSetForm" label-width="80px">
                <el-form-item v-for="(categoryId, index) in relationCategoryIds" :key="index" :label="'分类'+(index+1)">
                    <el-cascader v-model="relationCategoryIds[index]" :props="category" placeholder="请选择分类" style="width:100%" clearable></el-cascader>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="relationCategoryDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmitRelationCategory">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {quillRedefine} from 'vue-quill-editor-upload'//引入图片上传
export default {
    data() {
        let _this = this;
        return {
            modifyTemplate: false,
            loadedProduct: false,
            productSetForm: {
                id: "",
                name: "",
                categoryIds: [],
                relationCategoryIds: [],
                templateId: "",
                brandId: "",
                price: 0,
                delivery: "",
                description: "",
                thumbnail: "",
                unit: "",
                status: null,
                categoryId: "",
            },
            category: {
                label: "name",
                value: "id",
                lazy: true,
                checkStrictly: true,
                lazyLoad (node, resolve) {
                    if(_this.loadedProduct) {
                        _this.loadCategory(node, resolve);
                    } else {
                        let interval = setInterval(() => {
                            if(_this.loadedProduct) {
                                clearInterval(interval);
                                _this.loadCategory(node, resolve);
                            }
                        }, 500);
                    }
                }
            },
            relationCategory: {
                label: "name",
                value: "id",
                lazy: true,
                multiple: true,
                checkStrictly: true,
                lazyLoad (node, resolve) {
                    if(_this.loadedProduct) {
                        _this.loadCategory(node, resolve);
                    } else {
                        let interval = setInterval(() => {
                            if(_this.loadedProduct) {
                                clearInterval(interval);
                                _this.loadCategory(node, resolve);
                            }
                        }, 500);
                    }
                }
            },
            loading: false,
            productData: [],
            productTotal: 0,
            productPageSize: 10,
            productCurrentPage: 1,
            brandLoading: false,
            brands: [],
            templateLoading: false,
            templates: [],
            fileList: [],
            editorOption:{},
            relationCategoryIds:[],
            images: [],
            productForm: {
                id: "",
                name: "",
                sku: "",
                model: "",
                setId: "",
                brandId: "",
                templateId: "",
                itemNumber: "",
                categoryId: "",
                price: 0,
                delivery: "",
                unit: "",
                categoryIds: [],
                relationCategoryIds: [],
                properties: [],
                images: [],
                thumbnail: "",
                description: "",
                status: "1",
                recommend: "",
            },
            editDialogVisible: false,
            valueLoading: false,
            dialogPreviewVisible: false,
            relationCategoryDialogVisible: false,
            dialogImageUrl: "",
            imageList: [],
            rules: {
                name: [
                    { required: true, message: '请输入商品名称', trigger: 'blur' }
                ],
                categoryIds: [
                    { required: true, message: '请选择商品分类', trigger: 'blur' }
                ],
                templateId: [
                    { required: true, message: '请选择属性模板', trigger: 'blur' }
                ],
                // thumbnail: [
                //     { required: true, message: '请上传封面图', trigger: 'blur' }
                // ],
                sku: [
                    { required: true, message: '请输入商品编号', trigger: 'blur' }
                ],
            },
        }
    },
    props: ["productSetId"],
    methods: {
        init() {
            let _this = this;
            if(this.productSetId == undefined || this.productSetId == "") {
                _this.modifyTemplate = true;
                _this.loadedProduct = true;
                return;
            } else {
                _this.modifyTemplate = false;
                this.$axios.get("/admin/product/set/" + this.productSetId)
                .then(function(response){
                    let resp = response.data;
                    _this.loadedProduct = true;
                    if(resp.header.status == 0) {
                        _this.productSetForm = resp.data;
                        _this.productSetForm.status = _this.productSetForm.status + "";
                        // if(_this.productSetForm.status === '1') {
                        //     _this.modifySet = true;
                        // }
                        _this.fileList = [{name: "", url: ''}];
                        _this.onSearchProduct()
                        _this.$axios.post("/admin/product/brand/list", {
                            id: _this.productSetForm.brandId,
                        })
                        .then(function(response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {
                                _this.brands = resp.data;
                                _this.$axios.post("/admin/property/template/list", {
                                    id: _this.productSetForm.templateId,
                                })
                                .then(function(response) {
                                    let resp = response.data;
                                    if (resp.header.status == 0) {
                                        _this.templates = resp.data;
                                        _this.changeTemplate(_this.productSetForm.templateId);
                                    }
                                }).catch(function() {});
                            }
                        }).catch(function() {});
                    }
                })
                .catch(function(){});
            }
        },
        loadBrand(query) {
            if(query=="") return;
            this.brandLoading = true;
            let _this = this;
            this.$axios.post("/admin/product/brand/contain", {
                nameCh: query,
            }).then(function(response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.brandLoading = false;
                    _this.brands = resp.data;
                }
            })
            .catch(function() {});
        },
        loadTemplate(query) {
            if(query=="") return;
            this.templateLoading = true;
            let _this = this;
            this.$axios.post("/admin/property/template/list", {
                name: query,
            }).then(function(response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.templateLoading = false;
                    _this.templates = resp.data;
                }
            })
            .catch(function() {});
        },
        loadCategory(node, resolve) {
            let _this = this;
            let params = {};
            if(node.root) {
                params["fid"] = "root";
            } else {
                params["fid"] = node.value;
            }
            _this.$axios.post("/admin/product/category/list", params)
            .then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    resolve(resp.data);
                }
            }).catch(function () {
            });
        },
        changeTemplate(value) {
            let _this = this;
            this.$axios
            .get("/admin/property/template/listProperty/" + value)
            .then(function(response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.loading = false;
                    _this.productForm.properties = resp.data;
                }
            })
            .catch(function() {});
        },
        //文件上传成功的钩子函数
        handleSuccess(res, file) {
            if (file.response.data.success) {
                this.$message({
                    type: 'info',
                    message: '图片上传成功',
                    duration: 6000
                });
                this.productSetForm.thumbnail = file.response.data.message; //将返回的文件储存路径赋值picture字段
            } else {
                this.$message({
                    type: 'info',
                    message: '图片上传失败',
                    duration: 6000
                });
            }
        },
        //删除文件之前的钩子函数
        handleRemove() {
            this.productSetForm.thumbnail = "";
            this.$message({
                type: 'info',
                message: '已删除原有图片',
                duration: 6000
            });
        },
        //点击列表中已上传的文件事的钩子函数
        handlePreview() {
        },
        //上传的文件个数超出设定时触发的函数
        onExceed() {
        },
        //文件上传前的前的钩子函数
        //参数是上传的文件，若返回false，或返回Primary且被reject，则停止上传
        beforeUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isGIF = file.type === 'image/gif';
            const isPNG = file.type === 'image/png';
            const isBMP = file.type === 'image/bmp';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG && !isGIF && !isPNG && !isBMP) {
                this.$message.error('上传图片必须是JPG/GIF/PNG/BMP 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
        },
        //文件上传成功的钩子函数
        handleImageSuccess(res, file) {
            if (file.response.data.success) {
                this.$message({
                    type: 'info',
                    message: '图片上传成功',
                    duration: 6000
                });
                this.images.push({name:file.name, url:"/api"+file.response.data.message});
            } else {
                this.$message({
                    type: 'info',
                    message: '图片上传失败',
                    duration: 6000
                });
            }
        },
        //删除文件之前的钩子函数
        handleImageRemove(file) {
            let bDelete = false;
            for(var i=0; i<this.images.length; i++) {
                if(this.images[i].name == file.name) {
                    this.images.splice(i, 1);
                    bDelete =true;
                }
            }
            if(bDelete) {
                this.$message({
                    type: 'info',
                    message: '图片删除成功',
                    duration: 6000
                });
            }
        },
        //点击列表中已上传的文件事的钩子函数
        handleImagePreview() {
        },
        //上传的文件个数超出设定时触发的函数
        onImageExceed() {
            this.$message({
                type: 'info',
                message: '最多只能上传三张图片',
                duration: 6000
            });
        },
        //文件上传前的前的钩子函数
        //参数是上传的文件，若返回false，或返回Primary且被reject，则停止上传
        beforeImageUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isGIF = file.type === 'image/gif';
            const isPNG = file.type === 'image/png';
            const isBMP = file.type === 'image/bmp';
            const isLt2M = file.size / 1024 / 1024 < 2;
            var distinct = true;
            for(var i=0; i<this.images.length; i++) {
                if(this.images[i].name == file.name) {
                    distinct = false;
                    break;
                }
            }
            if (!isJPG && !isGIF && !isPNG && !isBMP) {
                this.$message.error('上传图片必须是JPG/GIF/PNG/BMP 格式!');
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }
            if(!distinct) {
                this.$message.error('不能上传相同的图片');
            }
            return (isJPG || isBMP || isGIF || isPNG) && isLt2M && distinct;
        },
        onSubmitProductSet() {
            let that = this;
            this.$refs.productSetForm.validate(valid => {
                if (valid) {
                    this.$axios.post("/admin/product/set/save", this.productSetForm)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status == 0) {
                            that.productSetId = resp.data.id;
                            that.productSetForm.id = resp.data.id;
                            that.$notify({
                                title: '成功',
                                message: '数据保存成功',
                                type: 'success'
                            });
                            that.editDialogVisible = false;
                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
                }
            });
        },
        goBack() {
            this.$router.go(-1);
        },
        priceFormatter(row, column, cellValue) {
            return "￥" + cellValue + "元";
        },
        showMoreCategoryDialog() {
            this.relationCategoryIds = [];
            for(let i=0; i<this.productSetForm.relationCategoryIds.length; i++) {
                this.relationCategoryIds.push(this.productSetForm.relationCategoryIds[i]);
            }
            var len = this.relationCategoryIds.length;
            for(let i=10; i>len; i--) {
                this.relationCategoryIds.push([]);
            }
            this.relationCategoryDialogVisible = true;
        },
        onSearchProduct() {
            if(this.productSetForm.id == "") {
                this.productData = [];
                return;
            }
            this.loading = true;
            let _this = this;
            this.$axios.post("/admin/product/search", {
                cond: {
                    setId: this.productSetForm.id,
                },
                page: this.productCurrentPage - 1
            })
            .then(function(response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.loading = false;
                    _this.productData = resp.data.content;
                    _this.productTotal = resp.data.totalElements;
                }
            })
            .catch(function() {});
        },
        tabClick(tab) {
            if(tab.index == "1") {
                this.onSearchProduct();
            }
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.productCurrentPage = currentPage;
            this.onSearchProduct();
        },
        handleCreateProduct() {
            this.productForm.id = "";
            this.productForm.name = "";
            this.productForm.model = "";
            this.productForm.setId = "";
            this.productForm.brandId = "";
            this.productForm.templateId = "";
            this.productForm.sku = "";
            this.productForm.delivery = "";
            this.productForm.unit = "";
            this.productForm.price = 0;
            this.productForm.categoryIds = "";
            this.productForm.relationCategoryIds = [];
            this.images = [];
            this.productForm.status = "1";
            this.productForm.recommend = "0";
            for(var i=0; i<this.productForm.properties.length; i++) {
                this.productForm.properties[i].value = "";
            }
            this.editDialogVisible = true;
        },
        handleEditProduct(index, row) {
            let that = this;
            this.productForm.id = row.id;
            this.productForm.name = row.name;
            this.productForm.model = row.model;
            this.productForm.setId = row.setId;
            this.productForm.brandId = row.brandId;
            this.productForm.templateId = row.templateId;
            this.productForm.itemNumber = row.itemNumber;
            this.productForm.sku = row.sku;
            this.productForm.delivery = row.delivery;
            this.productForm.unit = row.unit;
            this.productForm.price = row.price;
            this.productForm.categoryIds = "";
            this.productForm.relationCategoryIds = [];
            this.images = [];
            this.productForm.images = [];
            if(row.image) {
                var images = row.image.split(";");
                for(var i=0; i<images.length; i++) {
                    this.imageList.push({url:images[i]});
                    var paths = images[i].split("/");
                    this.images.push({name:paths[paths.length-1] ,url:"/api"+images[i]});
                }
            }
            this.productForm.status = row.status + "";
            this.productForm.recommend = row.recommend + "";
            this.$axios.get("/admin/product/" + row.id)
            .then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    for(var i=0; i<that.productForm.properties.length; i++) {
                        for(var j=0; j<resp.data.properties.length; j++) {
                            if(that.productForm.properties[i].key == resp.data.properties[j].key) {
                                that.productForm.properties[i].value = resp.data.properties[j].value;
                            }
                        }
                    }
                    that.editDialogVisible = true;
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            })

        },
        handleToPending(index, row) {
            let that = this;
            this.$axios.post("/admin/product/toPending", { id: row.id })
            .then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    that.$notify({
                        title: '成功',
                        message: '数据提交成功',
                        type: 'success'
                    });
                    that.onSearchProduct();
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            });
        },
        handleToPendingOff(index, row) {
            let that = this;
            this.$axios.post("/admin/product/off", [row.id] )
            .then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    that.$notify({
                        title: '成功',
                        message: '数据提交成功',
                        type: 'success'
                    });
                    that.onSearchProduct();
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            });
        },
        onSubmitProduct() {
            let _this = this;
            if(this.productSetForm.id==null||this.productSetForm.id==''){
                _this.$notify.error({
                    title: '错误',
                    message: '请先保存商品基本属性',
                });
            }
            this.productForm.setId = this.productSetForm.id;
            this.productForm.brandId = this.productSetForm.brandId;
            this.productForm.templateId = this.productSetForm.templateId;
            this.productForm.thumbnail = this.productSetForm.thumbnail;
            this.productForm.images = [];
            for(var i=0; i<this.images.length; i++) {
                this.productForm.images.push({
                    name: this.images[i].name,
                    url: this.images[i].url.replace(/^\/api/, ""),
                    uid: this.images[i].uid,
                    status: this.images[i].status
                });
            }
            this.productForm.categoryIds = this.productSetForm.categoryIds;
            this.productForm.relationCategoryIds = this.productSetForm.relationCategoryIds;
            this.$axios.post("/admin/product/save", this.productForm)
            .then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.$notify({
                        title: '成功',
                        message: '数据保存成功',
                        type: 'success'
                    });
                    _this.onSearchProduct();
                    _this.editDialogVisible = false;
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            });
        },
        initQuill() {
            this.editorOption = quillRedefine(//修改富文本编辑器图片上传路径
                {
                    // 图片上传的设置
                    uploadConfig: {
                        action: "/api/admin/upload",  // 必填参数 图片上传地址
                        res: (respnse) => {
                            return '/api'+ respnse.data.message;//return图片url
                        },
                        name: 'file'  // 图片上传参数名
                    }
                })
        },
        onSubmitRelationCategory() {
            this.productSetForm.relationCategoryIds = [];
            for(var i=0; i<this.relationCategoryIds.length; i++) {
                if(this.relationCategoryIds[i].length>0) {
                    this.productSetForm.relationCategoryIds.push(this.relationCategoryIds[i]);
                }
            }
            this.relationCategoryDialogVisible = false;
        },
        deliveryFormatter(row, column, cellValue) {
            return cellValue ? cellValue + "天" : "未定";
        },
    },
    created() {
        this.init();
        this.initQuill();
    },
}
</script>
<style>
</style>